var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 35,
    viewBox: "0 0 50 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2305 2.64124H6.5638C6.04868 2.64124 5.53861 2.7427 5.0627 2.93982C4.58679 3.13695 4.15437 3.42588 3.79013 3.79013C3.0545 4.52575 2.64124 5.52347 2.64124 6.5638V30.2305C2.64124 31.2708 3.0545 32.2685 3.79013 33.0042C4.15437 33.3684 4.58679 33.6573 5.0627 33.8545C5.53861 34.0516 6.04868 34.153 6.5638 34.153H30.2305C31.2708 34.153 32.2685 33.7398 33.0042 33.0042C33.7398 32.2685 34.153 31.2708 34.153 30.2305V6.5638C34.153 5.52347 33.7398 4.52575 33.0042 3.79013C32.2685 3.0545 31.2708 2.64124 30.2305 2.64124Z",
    fill: "#E5E8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7731 5.73519L36.7791 11.9391V24.8556L45.7731 31.0513C47.5129 32.2494 49.9091 31.0267 49.9091 28.9341V7.85239C49.9091 5.76801 47.5211 4.53708 45.7731 5.73519Z",
    fill: "#BEC6CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5892 1H4.92256C3.88224 1 2.88452 1.41327 2.14889 2.14889C1.41327 2.88452 1 3.88224 1 4.92256L1 28.5892C1 29.6296 1.41327 30.6273 2.14889 31.3629C2.88452 32.0985 3.88224 32.5118 4.92256 32.5118H28.5892C29.1044 32.5118 29.6144 32.4103 30.0903 32.2132C30.5663 32.0161 30.9987 31.7272 31.3629 31.3629C31.7272 30.9987 32.0161 30.5663 32.2132 30.0903C32.4104 29.6144 32.5118 29.1044 32.5118 28.5892V4.92256C32.5118 4.40745 32.4104 3.89737 32.2132 3.42146C32.0161 2.94556 31.7272 2.51314 31.3629 2.14889C30.9987 1.78465 30.5663 1.49571 30.0903 1.29859C29.6144 1.10146 29.1044 1 28.5892 1V1ZM44.1318 4.09374L35.1378 10.2976V23.2142L44.1318 29.4099C45.8715 30.608 48.2677 29.3852 48.2677 27.2927V6.21094C48.2677 4.12656 45.8797 2.89563 44.1318 4.09374Z",
    stroke: "black",
    strokeWidth: 0.33993,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.2d1a7ca27743d38c65215e2b60dafdef.svg";
export { ForwardRef as ReactComponent };